module.exports = __webpack_public_path__ + "static/media/linkedin-dark.06e3d620.svg";